import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-patrol`;
let baseUrl3 = `${httpUrl.host}/gy-apartment`;

let api = {
  // 导入巡更点
  importPatrolPoint: `${baseUrl}/patrolPointManage/import`,

  // 导出巡更点
  exportPatrolPoint: `${baseUrl}/patrolPointManage/export`,

  // 添加巡更点
  addPatrolPoint: `${baseUrl}/patrolPointManage/add`,

  // 修改巡更点
  updatePatrolPoint: `${baseUrl}/patrolPointManage/update`,

  // 删除巡更点
  deletePatrolPointByCodes: `${baseUrl}/patrolPointManage/deleteByCodes`,

  // 获取巡更点分页
  getPatrolPointPage: `${baseUrl}/patrolPointManage/getPage`,

  // 获取巡更点详情
  getPatrolPointByCode: `${baseUrl}/patrolPointManage/getByCode`,

  // 获取巡更点列表
  getPatrolPointList: `${baseUrl}/patrolPointManage/getList`,

  // 添加巡更路线
  addPatrolRoute: `${baseUrl}/patrolRoute/add`,

  // 修改巡更路线
  updatePatrolRoute: `${baseUrl}/patrolRoute/update`,

  // 删除巡更路线
  deletePatrolRouteByCodes: `${baseUrl}/patrolRoute/deleteByCodes`,

  // 获取巡更路线分页
  getPatrolRoutePage: `${baseUrl}/patrolRoute/getPage`,

  // 获取巡更路线详情
  getPatrolRouteByCode: `${baseUrl}/patrolRoute/getByCode`,

  // 获取巡更路线列表
  getPatrolRouteList: `${baseUrl}/patrolRoute/getList`,

  // 添加班组
  addPatrolTeam: `${baseUrl}/patrolTeamManage/add`,

  // 修改班组
  updatePatrolTeam: `${baseUrl}/patrolTeamManage/update`,

  // 删除班组
  deletePatrolTeamByCodes: `${baseUrl}/patrolTeamManage/deleteByCodes`,

  // 获取班组分页
  getPatrolTeamPage: `${baseUrl}/patrolTeamManage/getPage`,

  // 获取班组详情
  getPatrolTeamByCode: `${baseUrl}/patrolTeamManage/getByCode`,

  // 获取班组列表
  getPatrolTeamList: `${baseUrl}/patrolTeamManage/getList`,

  // 添加排班
  addPatrolRoster: `${baseUrl}/patrolRoster/add`,

  // 修改排班
  updatePatrolRoster: `${baseUrl}/patrolRoster/update`,

  // 删除排班
  deletePatrolRosterByCodes: `${baseUrl}/patrolRoster/deleteByCodes`,

  // 获取排班分页
  getPatrolRosterPage: `${baseUrl}/patrolRoster/getPage`,

  // 获取排班详情
  getPatrolRosterByCode: `${baseUrl}/patrolRoster/getByCode`,

  // 获取排班列表
  getPatrolRosterList: `${baseUrl}/patrolRoster/getList`,

  // 获取巡更记录
  getPatrolRecordPage: `${baseUrl}/patrolRecord/getPage`,

  // 人员列表
  getResponsiblePersonList: `${baseUrl3}/person/getResponsiblePersonList`,

  //巡更任务——分页
  getPatrolTaskPage: `${baseUrl}/patrolTask/getPage`,

  //巡更报表——分页
  getPatrolReportPage: `${baseUrl}/patrolReport/getPage`,

  //巡更报表——分页
  exportPatrolReport: `${baseUrl}/patrolReport/export`,

  //巡更详情——分页
  getPatrolTaskDetailPage: `${baseUrl}/patrolTask/detail`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/KeepWatch.js